import { ActionMap } from "@context/types/index";

export enum TypesPage {
  Previous = "PREVIOUS",
  Next = "NEXT",
  Reset = "RESET",
}

export type PagePayload = {
  [TypesPage.Previous]: undefined;
  [TypesPage.Next]: undefined;
  [TypesPage.Reset]: undefined;
};

export type PageActions = ActionMap<PagePayload>[keyof ActionMap<PagePayload>];
